import { Box } from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";
import Datetime from "react-datetime";
import { JobEstimationDetail } from "../../../modals/JobEstimationDetail";

require('./PickUpCalendar.css')


interface PickUpProps {
    estimateDetails: JobEstimationDetail;
    setDateSelected: Function,
    preSelectedDate: Date | undefined
}

const PickUpCalendar = (props: PickUpProps) => {

    const [selectedDate, setSelectedDate] = useState(props.preSelectedDate);

    const onDateSelected = (value: any) => {
        setSelectedDate(value);
        props.setDateSelected(value);
    }

    return (
        <div>
            <br></br>
            <Box>
                <Datetime
                    value={selectedDate}
                    open={true}
                    input={false}
                    renderDay={(cProps, currentDate, selectedDate) => {
                        let value = props.estimateDetails.expectedPickup;
                        if (currentDate.diff(value, 'days') < 3 && currentDate.diff(value, 'days') > -1 &&
                            moment().isSameOrBefore(currentDate, "days")) {
                            cProps.className += " pickUpDates";
                        }
                        if (selectedDate && currentDate.startOf("day").isSame(selectedDate, "day")) {
                            cProps.className += " selectedDate";
                        }

                        return <td {...cProps}>{currentDate.date()}</td>;
                    }}
                    isValidDate={(currentDate, selectedDate) => {
                        let value = props.estimateDetails.expectedPickup;
                        if (currentDate.diff(value, 'days') < 3 && currentDate.diff(value, 'days') > -1 &&
                            moment().isSameOrBefore(currentDate, "days")) {
                            return true;
                        } else { return false; }
                    }}
                    onChange={onDateSelected}></Datetime>
            </Box>
        </div>
    );
};

export default PickUpCalendar;